import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    DispatchBeginLoadProducts,
    DispatchCompleteLoadProducts,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
    RequestDataFromApi,
    SortCollections,
    SortFacets,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = (
    | GetProductCollectionApiV2Parameter
    | GetRelatedProductCollectionApiV2Parameter
    | GetAlsoPurchasedProductCollectionApiV2Parameter
) &
    HasOnSuccess<ProductModel[]> &
    HasOnError<string> & { id?: string };
type Props = {
    apiParameter:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginLoadProductsCustom: HandlerType = props => {
    props.dispatch({
        type: "Custom/PurchasedProducts/BeginEndLoadProducts",
        id: props.parameter.id,
        loading: true,
    } as any);
};

export const DispatchCompleteLoadProductsCustom: HandlerType = props => {
    props.dispatch({
        type: "Custom/PurchasedProducts/CompleteLoadProducts",
        id: props.parameter.id,
        pagination: props.apiResult.pagination,
    } as any);
};

export const DispatchEndLoadProductsCustom: HandlerType = props => {
    props.dispatch({
        type: "Custom/PurchasedProducts/BeginEndLoadProducts",
        id: props.parameter.id,
        loading: false,
    } as any);
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadProducts,
    DispatchBeginLoadProductsCustom,
    RequestDataFromApi,
    SortFacets,
    SortCollections,
    DispatchCompleteLoadProducts,
    DispatchCompleteLoadProductsCustom,
    DispatchEndLoadProductsCustom,
    ExecuteOnSuccessCallback,
];

const loadProducts = createHandlerChainRunner(chain, "LoadProducts");
export default loadProducts;
